export default __webpack_public_path__ + "static/media/taobao2.27a337f0.jpg";